module.exports = __webpack_public_path__ + "img/header-setting.ee610ac9.png";